import styled from 'styled-components';
import ReactTooltip from 'react-tooltip';

export const ToolTipBox = styled(ReactTooltip)`
  & .multi-line {
    line-height: 1;
  }
`;
